import { useContext } from "react";
import { UserContext } from "../contexts/UserContext";
import {
  DASHBOARD_PERMISSION_CODES,
  hasPermission,
} from "../permissions";

export const ACCESS_LEVEL = {
  SCHOOL: "school",
  TEACHER: "teacher",
};

// School wins when a user has both school and teacher perms.
export default function useAccessLevel() {
  const { user } = useContext(UserContext);
  if (hasPermission(user, DASHBOARD_PERMISSION_CODES.SCHOOL_VIEW)) {
    return ACCESS_LEVEL.SCHOOL;
  }
  if (hasPermission(user, DASHBOARD_PERMISSION_CODES.TEACHER_VIEW)) {
    return ACCESS_LEVEL.TEACHER;
  }
  return null;
}
